import { useCallback, useEffect, useMemo, useState } from 'react';
import { Colleague } from 'models/DealRoom';
import api from 'api';
import useCallbackAsync from './useCallbackAsync';
import { sortColleagues } from 'utils';

export default function useColleagues(dealRoomId: string) {
  const [colleagues, setColleagues] = useState<Colleague[]>([]);

  const [getColleagues, isLoading] = useCallbackAsync(async () => {
    const { data } = await api.dealRoom.getColleagues(dealRoomId);
    setColleagues(data);
  });

  const sortedColleagues = useMemo(
    () => sortColleagues(colleagues),
    [colleagues],
  );

  const onNewOwner = useCallback(
    (newOwner: Colleague) => {
      setColleagues((prev) => {
        let newOwnerAlreadyColleague = false;

        const updated = prev.map((colleague) => {
          if (newOwner._id === colleague._id) {
            newOwnerAlreadyColleague = true;
            return newOwner;
          }

          if (colleague.isOwner) {
            return { ...colleague, isOwner: false };
          }

          return colleague;
        });

        if (newOwnerAlreadyColleague) {
          return updated;
        }

        return [newOwner, ...updated];
      });
    },
    [setColleagues],
  );

  useEffect(() => {
    getColleagues();
  }, [getColleagues]);

  return { isLoading, colleagues: sortedColleagues, setColleagues, onNewOwner };
}
